import { useWorkspace } from '../lib/WorkspaceContext'

// Solo lista los workspaces de los que el usuario YA es miembro activo
// (workspaces viene de WorkspaceContext, que arma la lista desde
// workspace_miembros). Nunca debe convertirse en un directorio de todas
// las nutris de Juco — ver nota de arquitectura sobre esto.
export default function SelectorWorkspace({ onLogout, esSuperAdmin, onIrPanelSuperAdmin, onIrReportes }) {
  const { workspaces, elegirWorkspace } = useWorkspace()

  if (workspaces.length === 0) {
    return (
      <div className="app" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24 }}>
        <div className="empty-state" style={{ width: '100%', maxWidth: 320 }}>
          <div className="empty-icon">🌿</div>
          <p>Todavía no estás vinculado a ningún espacio. Si tenés una invitación pendiente, abrí el link que te mandamos por mail.</p>
          {esSuperAdmin && (
            <button className="btn-primario" style={{ marginTop: 16, width: '100%' }} onClick={onIrPanelSuperAdmin}>
              🛠 Panel super-admin
            </button>
          )}
          {esSuperAdmin && (
            <button className="btn-secundario" style={{ marginTop: 8, width: '100%' }} onClick={onIrReportes}>
              📬 Bandeja de reportes
            </button>
          )}
          <button className="btn-secundario" style={{ marginTop: 16, width: '100%' }} onClick={onLogout}>Cerrar sesión</button>
        </div>
      </div>
    )
  }

  return (
    <div className="app">
      <div className="page-header">
        <h1 className="page-titulo">Elegí tu espacio</h1>
        <p className="page-subtitulo">Pertenecés a más de un espacio en Juco</p>
      </div>
      <div className="contenido" style={{ padding: 16, display: 'flex', flexDirection: 'column', gap: 12 }}>
        {workspaces.map(w => (
          <button
            key={w.id}
            className="btn-primario"
            style={{ background: w.color_primario || 'var(--verde-dark)', textAlign: 'left' }}
            onClick={() => elegirWorkspace(w.id)}
          >
            {w.nombre}
          </button>
        ))}
      </div>
    </div>
  )
}
